/* src/app/pages/auth/signup/signup.component.scss */
.center_div {
  margin-top: 10px;
  margin-left: 50px;
  width: 70%;
}
.invalid-feedback {
  color: #f44336;
}
.linkAriadne {
  font-size: 18px;
  float: right;
  color: black;
}
.linkAriadne:hover {
  color: red;
}
.imgAriadne {
  height: 60px !important;
}
/*# sourceMappingURL=signup.component.css.map */
